import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { ProductBundleItemModel } from '@libs/shop/models';
import { ProductPriceFormatterComponent } from '../../../catalog/product-prices/product-price-formatter';

@Component({
  selector: 'ui-configurable-bundle-order-card-item',
  imports: [
    ProductPriceFormatterComponent,
    MatTooltip,
  ],
  templateUrl: './configurable-bundle-order-card-item.component.html',
  styleUrl: 'configurable-bundle-order-card-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.free-item]': 'bundleItem().slotType === "free"',
    '[class.non-free-item]': 'bundleItem().slotType !== "free"',
  },
})
export class ConfigurableBundleOrderCardItemComponent {
  public bundleItem: InputSignal<ProductBundleItemModel> = input.required();
}
